import { render } from "./Directors.vue?vue&type=template&id=1dafb62e&scoped=true"
import script from "./Directors.vue?vue&type=script&lang=js"
export * from "./Directors.vue?vue&type=script&lang=js"

import "./Directors.vue?vue&type=style&index=0&id=1dafb62e&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dafb62e"]])

export default __exports__